/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONTRATOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterAtestos(ano) {
        return axiosJwt
            .get(`${api}/contratos/atestos?ano=${ano}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAtestoPorId(id) {
        return axiosJwt
            .get(`${api}/contratos/atestos/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    naoAtestar(naoAtesto) {
        return axiosJwt
            .post(
                `${api}/contratos/atestos/${naoAtesto.idRegistroAtestoPagamento}/naoatestar`,
                naoAtesto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atestar(atesto) {
        return axiosJwt
            .post(
                `${api}/contratos/atestos/${atesto.idRegistroAtestoPagamento}/atestar`,
                atesto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
